// Module extracted from tinybox2
define('dialog/position',['event', 'utils/user_agent'], function(Event,UA) {
  return {
    pos: function(){
      function setDialogPosition(dialog, w, h){
        var t, l;
        t = (dialog.docHeight() - h)/2;
        l = (dialog.docWidth() - w)/2;
        t = t < 10 ? 10 : t;
        l = l < 0 ? 0 : l;
        if(UA.mobile()){
          t+=document.body.scrollTop;
        }
        dialog.setTop(t);
        dialog.setLeft(l);
      }

      this.subscribe('dialog.resize', function(w, h, overflow){
        setDialogPosition(this, w, h);
      });

      setDialogPosition(this, this.width(), this.height());
    },

    docTop: function() { return document.documentElement.scrollTop||document.body.scrollTop; },
    docWidth: function() { return self.innerWidth||document.documentElement.clientWidth||document.body.clientWidth; },
    docHeight: function() { return self.innerHeight||document.documentElement.clientHeight||document.body.clientHeight; },

    hide: function(){
      this.hidden = true;
      this.setTop(-10000);
      this.hideMask();
      Event.fire('dialog.hide', this);
    },

    show: function(){
      this.hidden = false;
      this.pos();
      this.showMask();
      Event.fire('dialog.show', this);
    },

    resizeMask: function(){
      var b=document.body, e=document.documentElement;
      this.mask.style.height = Math.max(Math.max(b.scrollHeight,e.scrollHeight),Math.max(b.clientHeight,e.clientHeight)) + 'px';
      this.mask.style.width = Math.max(Math.max(b.scrollWidth,e.scrollWidth),Math.max(b.clientWidth,e.clientWidth)) + 'px';
    },

    showMask: function(){
      this.resizeMask();
      this.mask.style.display = 'block';
    },

    hideMask: function(){
      this.mask.style.display = 'none';
    }
  };
});

